import { ICommand, IDatasource, IDefineCommand, IQuery, IQueryMediator, key } from 'core-ts-types';
angular
  .module('capability-ng-academic-planner')
  .service('createEmptyTermsCommand', ($http: ng.IHttpService, log: any, defineCommand: IDefineCommand) =>
    defineCommand(
      'createEmptyTermsCommand',
      (deferred: ng.IDeferred<IQuery[]>, time_commitment: string, term_preference: string[]) =>
        $http
          .post(`academicplan/quickplan/`, {
            time_commitment,
            term_preference,
            create_empty_terms: true
          })
          .catch((e: string) => {
            log.issue('unable to complete intake survey');
            deferred.reject(e);
          })
    )
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/preview_plan/commands/create_empty_terms_command.ts